import type { MeansOfTransportationMetrics } from '../../components/charts/MeansOfTransportation';
import { MODE_SHARE_CLOSEOUT, renderCloseoutBundle } from './closeoutTransportCopy';
import { buildCommuteModeShareNarrativeTokens } from './commuteModeShareNarrativeTokens';

export function buildCommuteModeShareAuthoredBundle(
  locationName: string,
  metrics: MeansOfTransportationMetrics | null
) {
  const tokens = buildCommuteModeShareNarrativeTokens(locationName, metrics);
  return renderCloseoutBundle(MODE_SHARE_CLOSEOUT, tokens, {
    chartId: 'mode_share',
    viewId: 'default',
  });
}

export function commuteModeShareOverviewDescription(): string {
  return MODE_SHARE_CLOSEOUT.overview;
}

export function buildCommuteModeShareKeyInsights(
  locationName: string,
  metrics: MeansOfTransportationMetrics | null
): string {
  const bundle = buildCommuteModeShareAuthoredBundle(locationName, metrics);
  return bundle.keyInsights || `Commute mode data are not available for ${locationName}.`;
}
